import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  height: "24px",
  viewBox: "0 0 24 24",
  width: "24px",
  fill: "currentColor"
}
const _hoisted_3 = { class: "p-info" }
const _hoisted_4 = {
  class: "bold",
  notranslate: ""
}
const _hoisted_5 = { class: "p-age" }
const _hoisted_6 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[2] || (_cache[2] = _createElementVNode("div", null, null, -1)),
    _createElementVNode("button", {
      class: _normalizeClass(["p-button flex-row", { 'disabled-btn': _ctx.ageRestricted || _ctx.editState }]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onToggle())),
      disabled: _ctx.ageRestricted
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["p-check", { checked: _ctx.checked }])
      }, [
        (_ctx.checked)
          ? (_openBlock(), _createElementBlock("svg", _hoisted_2, _cache[1] || (_cache[1] = [
              _createElementVNode("path", {
                d: "M0 0h24v24H0V0z",
                fill: "none"
              }, null, -1),
              _createElementVNode("path", { d: "M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" }, null, -1)
            ])))
          : _createCommentVNode("", true)
      ], 2),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.name), 1),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", null, _toDisplayString(_ctx.age) + " years old", 1),
          (_ctx.ageRestricted)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, "Minor must be at least " + _toDisplayString(_ctx.minAge) + " to participate in this activity.", 1))
            : _createCommentVNode("", true)
        ])
      ])
    ], 10, _hoisted_1)
  ], 64))
}